export const API_TOOLS_URL: string = process.env.NX_API_TOOLS || '';
export const PICSART_API_BASE_URL = process.env.NX_PICSART_API || '';
export const AUTH_REDIRECT_URL: string = process.env.NX_AUTH_REDIRECT || '';
export const AUTH_CLIENT_ID = process.env.NX_AUTH_CLIENT_ID || '';
export const AUTH_POPUP_BASE = process.env.NX_AUTH_POPUP_BASE || '';
export const AUTH_ACCEPTED_ORIGIN = process.env.NX_AUTH_ACCEPTED_ORIGIN || '';
